import { EnglishAccentType } from "../../ruleSets/accentRules";

export const accentColors: Record<EnglishAccentType, string> = {
  'Dictionary US': 'rgb(150,150,150)',
  'Dictionary UK': 'rgb(150,150,150)',
  'Western US': 'rgb(31, 141, 42)',
  'English RP': 'rgb(141, 31, 38)',
  'Cockney': 'rgb(141, 31, 38)',
  'Estuary': 'rgb(141, 31, 38)',
  'Scouse (Liverpool)': 'rgb(190, 123, 15)',
  'Brummie (Birmingham)': 'rgb(190, 123, 15)',
  'New Dublin': 'rgb(150,50,150)',
  'Local Dublin': 'rgb(150,50,150)',
  'Welsh (Cardiff)': 'rgb(197, 20, 20)',
  'Scottish': 'rgb(31, 75, 141)',
  'Glasgow': 'rgb(31, 75, 141)',
  'Australian': 'rgb(131, 126, 31)',
  'South African': 'rgb(100, 100, 100)',
  'Southern US': 'rgb(31, 141, 42)',
  'Shakespeare': 'rgb(60,140,160)',
}
export const yorkshireColor = 'rgb(50,150,150)';
export const vowelColor = 'rgb(42, 100, 85)';

export const join = '\u2060';  /** zero-width joiner to avoid linebreaks */
